import {Injectable, OnInit} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { createRequestOption } from '../common/utils/request-util';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  constructor(
    private http: HttpClient,
  ) {
  }
  getAllResource() {
    return this.http.get(environment.urlBackEnd + 'res/all',  {  observe: 'response' });
  }
  getAllLifeHero() {
    return this.http.get( environment.urlBackEnd + 'life-hero/resource/all');
  }
  getResourcePlanner() {
    return this.http.get(environment.urlBackEnd + 'res/financial-planner',  {  observe: 'response' });
  }
  public getProducts(body) {
    return  this.http.post(environment.API_FMARKET + '/res/products/filter', body);
  }
  loadSummaryConsultantRequest(){
    return this.http.get(environment.urlBackEnd + 'life-hero/partner/consult-request/summary');
  }
  queryConsultantRequest(body) {
    return this.http.post(environment.urlBackEnd + 'life-hero/partner/consult-request/list/', body);
  }
}
